const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Ready to Sell Your El Paso Home?
        </h2>
        <p className="text-xl mb-8 leading-relaxed max-w-3xl mx-auto">
          Get your fair cash offer today. No obligations, no pressure—just honest answers and a straightforward solution.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <a
            href="/get-cash-offer-for-my-property"
            className="bg-white text-teal-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors shadow-lg whitespace-nowrap inline-flex items-center justify-center"
          >
            <i className="ri-home-line mr-2 w-6 h-6 flex items-center justify-center"></i>
            Get Your Cash Offer
          </a>
          <a
            href="tel:+1-915-206-5814"
            className="bg-teal-800 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-teal-900 transition-colors shadow-lg whitespace-nowrap inline-flex items-center justify-center"
          >
            <i className="ri-phone-line mr-2 w-6 h-6 flex items-center justify-center"></i>
            Call Us Today
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <i className="ri-time-line text-4xl mb-3"></i>
            <h3 className="text-xl font-bold mb-2">Fast Response</h3>
            <p className="text-sm">We'll contact you within 24 hours</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <i className="ri-shield-check-line text-4xl mb-3"></i>
            <h3 className="text-xl font-bold mb-2">No Obligation</h3>
            <p className="text-sm">Get an offer with zero commitment</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <i className="ri-hand-heart-line text-4xl mb-3"></i>
            <h3 className="text-xl font-bold mb-2">Local & Trusted</h3>
            <p className="text-sm">Your El Paso neighbors since 2008</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
